/* LivaSonic · revelado por scroll con stagger (IntersectionObserver) */
(function () {
  function init() {
    var els = document.querySelectorAll('[data-mt-reveal]');
    if (!els.length) return;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        // Stagger entre hermanos con [data-mt-stagger] en el contenedor
        var parent = el.closest('[data-mt-stagger]');
        if (parent && !el.style.getPropertyValue('--mt-delay')) {
          var sibs = parent.querySelectorAll('[data-mt-reveal]');
          var idx = Array.prototype.indexOf.call(sibs, el);
          el.style.setProperty('--mt-delay', (idx * 70) + 'ms');
        }
        el.classList.add('mt-in');
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });

    els.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Re-inicializar en el editor de Shopify al añadir secciones
  document.addEventListener('shopify:section:load', init);
})();
